export const messages = {
    "wr-dashboard.search.input.hint": "Найти",
    "wr-dashboard.search.label.breadcrumb": "Результаты поиска",
    "wr-dashboard.search.message.empty": "По вашим условиям поиска нет результатов",
    "wr-dashboard.side-bar.selected.title:plural": "{count} элементов изменено | {count} элемент выбран | {count} элементов изменено | {count} элементов изменено | {count} элементов изменено",
    "wr-dashboard.side-bar.backup-type.disk": "Диск",
    "wr-dashboard.side-bar.backup-type.file": "Файл",
    "wr-dashboard.side-bar.backup-type.notarized": "Нотаризованные файлы и папки",
    "wr-dashboard.side-bar.backup-type.exchange": "Приложение — Microsoft Exchange",
    "wr-dashboard.side-bar.backup-type.sql": "Приложение — Microsoft SQL",
    "wr-dashboard.side-bar.backup-type.sys-state": "Приложение — состояние системы",
    "wr-dashboard.side-bar.backup-type.application": "Приложение",
    "wr-dashboard.backups-table.column.name": "Имя",
    "wr-dashboard.backups-table.column.size": "Размер",
    "wr-dashboard.backups-table.column.version": "Последняя версия",
    "wr-dashboard.backups-table.action.delete": "Удалить",
    "wr-dashboard.backups-table.message.no-backups": "В облаке еще нет резервных копий",
    "wr-dashboard.backups-sidebar.label.size": "Размер",
    "wr-dashboard.backups-sidebar.label.type": "Тип",
    "wr-dashboard.backups-sidebar.label.version": "Последняя версия",
    "wr-dashboard.backups-sidebar.label.created": "Создано",
    "wr-dashboard.backups-sidebar.label.machine": "Машина",
    "wr-dashboard.backups-sidebar.label.owner": "Владелец",
    "wr-dashboard.content-table.column.name": "Имя",
    "wr-dashboard.content-table.column.versions": "Версии",
    "wr-dashboard.content-table.column.volumes": "Тома",
    "wr-dashboard.content-table.column.path": "Путь",
    "wr-dashboard.content-table.column.size": "Размер",
    "wr-dashboard.content-table.column.version": "Последняя версия",
    "wr-dashboard.content-table.action.notary-verify": "Проверить",
    "wr-dashboard.content-table.action.notary-get-crt": "Получить сертификат",
    "wr-dashboard.content-table.action.asign": "Отправить на подпись",
    "wr-dashboard.content-table.action.versions": "Версии",
    "wr-dashboard.content-table.action.restore": "Загрузить",
    "wr-dashboard.content-table.label.size": "Размер",
    "wr-dashboard.content-table.label.created": "Создано",
    "wr-dashboard.content-table.label.modified": "Изменено",
    "wr-dashboard.content-table.message.empty-folder": "Эта папка пуста",
    "wr-dashboard.password-dialog-box.title.backup": "Шифрованная резервная копия",
    "wr-dashboard.password-dialog-box.title.archive": "Шифрованный архив",
    "wr-dashboard.password-dialog-box.message.backup": "Укажите пароль для доступа к резервной копии {displayName}",
    "wr-dashboard.password-dialog-box.message.archive": "Укажите пароль для доступа к архиву {displayName}",
    "wr-dashboard.password-dialog-box.hint.password": "Пароль",
    "wr-dashboard.password-dialog-box.message.invalid-password": "Неправильный пароль",
    "wr-dashboard.form.button.open": "Открыть",
    "wr-dashboard.form.button.close": "Закрыть",
    "wr-dashboard.form.button.cancel": "Отмена",
    "wr-dashboard.form.button.continue": "Продолжить",
    "wr-dashboard.form.button.proceed": "Продолжить",
    "wr-dashboard.form.button.delete": "Удалить",
    "wr-dashboard.form.button.done": "Готово",
    "wr-dashboard.form.button.retry": "Повторить",
    "wr-dashboard.notary.verify.view.status.downloading": "Загрузка...",
    "wr-dashboard.notary.verify.view.status.validating": "Проверка...",
    "wr-dashboard.notary.verify.view.status.pending": "Ожидание сертификата…",
    "wr-dashboard.notary.verify.view.status.fail": "Несоответствие сертификата...",
    "wr-dashboard.notary.verify.view.button.get-crt": "Получить сертификат",
    "wr-dashboard.notary.verify.view.file-info.name": "ИМЯ",
    "wr-dashboard.notary.verify.view.file-info.signed-by": "КЕМ ПОДПИСАН",
    "wr-dashboard.notary.verify.view.file-info.date-backed-up": "ДАТА РЕЗЕРВНОГО КОПИРОВАНИЯ",
    "wr-dashboard.notary.verify.view.file-info.date-notarized": "ДАТА НОТАРИЗАЦИИ",
    "wr-dashboard.notary.verify.view.button.cancel": "Отмена",
    "wr-dashboard.notary.verify.view.button.done": "Готово",
    "wr-dashboard.notary.warning.unsupported.browser.version": "Неподдерживаемая версия браузера",
    "wr-dashboard.versions-dialog-box.title": "Версии {fileName}",
    "wr-dashboard.asign-dialog-box.title": "Отправить на подпись",
    "wr-dashboard.asign-dialog-box.message": "К этой версии файла предоставлен общий доступ, но никто не может просмотреть файл без ссылки на него. Перейдите к ASign, чтобы добавить подписывающие стороны и предоставить общий доступ к ссылке.",
    "wr-dashboard.asign-dialog-box.button.show-signed-file-details": "Показать сведения о файле",
    "wr-dashboard.page-not-found.title": "Страница не найдена",
    "wr-dashboard.page-not-found.message.main": "Страница, которую вы искали, не найдена.",
    "wr-dashboard.page-not-found.message.description": "Возможно, ссылка устарела или вы ввели неправильный адрес.",
    "wr-dashboard.page-not-found.message.error": "Код ошибки: 404",
    "wr-dashboard.server-error.title": "Сервер недоступен.",
    "wr-dashboard.server-error.message": "В данный момент сервер недоступен. Повторите попытку позже.",
    "wr-dashboard.server-error.message.error": "Код ошибки: 500",
    "wr-dashboard.account-menu.action.sign-out": "Выйти",
    "wr-dashboard.breadcrumb.item.machines": "Машины",
    "wr-dashboard.breadcrumb.item.failed-backups": "Незавершенные резервные копии по причине сбоя",
    "wr-dashboard.machines-table.column.name": "Имя",
    "wr-dashboard.machines-table.column.size": "Размер",
    "wr-dashboard.machines-table.message.no-machines": "В облаке еще нет машин",
    "wr-dashboard.incomplete-backups.message.status:plural": "Незавершенные или неполные резервные копии (в количестве {count}) занимают {size} пространства | {count} неполная или незавершенная резервная копия занимает {size} пространства | Незавершенные или неполные резервные копии (в количестве {count}) занимают {size} пространства | Незавершенные или неполные резервные копии (в количестве {count}) занимают {size} пространства | Незавершенные или неполные резервные копии (в количестве {count}) занимают {size} пространства",
    "wr-dashboard.incomplete-backups.button.view": "Просмотреть резервные копии",
    "wr-dashboard.incomplete-backups.button.delete": "Удалить резервные копии",
    "wr-dashboard.machines-table.message.space-used:plural": "Общее использование резервных копий {size}",
    "wr-dashboard.delete-archive-dialog-box.title": "Удалить архивы",
    "wr-dashboard.delete-incomplete-archive-dialog-box.title": "Удалить неполные архивы",
    "wr-dashboard.delete-all-incomplete-archives-dialog-box.title": "Удалить все неполные архивы",
    "wr-dashboard.delete-archive.message": "Действительно окончательно удалить выбранные архивы из всех хранилищ? Все данные удаляются и не подлежат восстановлению.",
    "wr-dashboard.certificate-pending-dialog-box.title": "Ожидается сертификат",
    "wr-dashboard.certificate-pending-dialog-box.message": "Повторите попытку через несколько минут.",
    "wr-dashboard.form.button.ok": "ОК"
};
